import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { ContentLabelField, FormInputText, Grid, Text } from '@hopskipdrive/react-components';

import { ECGrid } from './styles';

type FormData = {
  billingAddress: string;
  accountName: string;
  primaryAcctPhoneNumber: string;
  ecName: string;
  ecEmail: string;
  ecPhoneNumber: string;
};

export interface AccountInfoProps {
  accountInfo?: AccountInfo;
  editMode: boolean;
}

const AccountInfo: FC<AccountInfoProps> = ({ accountInfo, editMode }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<FormData>();

  return (
    <Grid container>
      <Grid item xs={6} data-settings-column>
        <ContentLabelField
          id="billingAddress"
          title="Billing Address"
          description={<span>{accountInfo?.billingAddress}</span>}
          editMode={editMode}
          editView={
            <Controller
              control={control}
              name="billingAddress"
              defaultValue=""
              render={({ field: { value, onChange } }) => (
                <FormInputText
                  variant="outlined"
                  name="billingAddress"
                  value={value}
                  fullWidth
                  placeholder="Address"
                  error={!!errors.billingAddress}
                  helperText={errors.billingAddress?.message}
                  onChange={onChange}
                />
              )}
            />
          }
        />

        <ContentLabelField
          id="accountName"
          title="Account Name"
          description={<span>{accountInfo?.accountName}</span>}
          editMode={editMode}
          editView={
            <Controller
              control={control}
              name="accountName"
              defaultValue=""
              render={({ field: { value, onChange } }) => (
                <FormInputText
                  variant="outlined"
                  name="accountName"
                  value={value}
                  fullWidth
                  placeholder="Name"
                  error={!!errors.accountName}
                  helperText={errors.accountName?.message}
                  onChange={onChange}
                />
              )}
            />
          }
        />

        <ContentLabelField
          id="primaryAcctPhoneNumber"
          title="Primary Account Phone Number"
          description={
            <span>
              <NumberFormat
                value={accountInfo?.primaryAcctPhoneNumber}
                displayType={'text'}
                format="(###) ###-####"
                mask="_"
              />
            </span>
          }
          editMode={editMode}
          editView={
            <Controller
              control={control}
              name="primaryAcctPhoneNumber"
              defaultValue=""
              render={({ field: { value, onChange } }) => (
                <FormInputText
                  variant="outlined"
                  name="primaryAcctPhoneNumber"
                  value={value}
                  fullWidth
                  placeholder="Phone Number"
                  error={!!errors.primaryAcctPhoneNumber}
                  helperText={errors.primaryAcctPhoneNumber?.message}
                  onChange={onChange}
                />
              )}
            />
          }
        />

        <ContentLabelField
          id="emergencyContacts"
          title="Emergency Contact"
          description={
            <ECGrid container spacing={2} direction="column">
              <Grid item>
                <Text id="ecNameViewField">{accountInfo?.ecName || '-'}</Text>
              </Grid>
              <Grid item>
                <Text id="ecEmailViewField">{accountInfo?.ecEmail}</Text>
              </Grid>
              <Grid item>
                <Text id="ecPhoneNumberViewField">
                  <NumberFormat
                    value={accountInfo?.ecPhoneNumber}
                    displayType={'text'}
                    format="(###) ###-####"
                    mask="_"
                  />
                </Text>
              </Grid>
            </ECGrid>
          }
          editMode={editMode}
          editView={
            <Grid container spacing={2} direction="column">
              <Grid item>
                <Controller
                  control={control}
                  name="ecName"
                  defaultValue=""
                  render={({ field: { value, onChange } }) => (
                    <FormInputText
                      variant="outlined"
                      id="ecNameEditField"
                      name="ecName"
                      value={value}
                      fullWidth
                      placeholder="Name"
                      error={!!errors.ecName}
                      helperText={errors.ecName?.message}
                      onChange={onChange}
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Controller
                  control={control}
                  name="ecEmail"
                  defaultValue=""
                  render={({ field: { value, onChange } }) => (
                    <FormInputText
                      variant="outlined"
                      id="ecEmailEditField"
                      name="ecEmail"
                      value={value}
                      fullWidth
                      placeholder="Email"
                      error={!!errors.ecEmail}
                      helperText={errors.ecEmail?.message}
                      onChange={onChange}
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Controller
                  control={control}
                  name="ecPhoneNumber"
                  defaultValue=""
                  render={({ field: { value, onChange } }) => (
                    <FormInputText
                      variant="outlined"
                      id="ecPhoneNumberEditfield"
                      name="ecPhoneNumber"
                      fullWidth
                      placeholder="Phone Number"
                      value={value}
                      error={!!errors.ecPhoneNumber}
                      helperText={errors.ecPhoneNumber?.message}
                      onChange={onChange}
                    />
                  )}
                />
              </Grid>
            </Grid>
          }
        />
      </Grid>
    </Grid>
  );
};

export default AccountInfo;
